import { useCompaniesStorage, useWorkspaceStorage } from '@pn/core/storage';
import { apiCompanyInfoProvider } from '@pn/services/api/intel/apiCompanyInfoProvider';
import { isEmpty } from 'lodash-es';
import React from 'react';
import { useIntelReportsStorage } from 'src/application/storage';

type BOEIntelType = {
  isDataInitialized: boolean;
  possibleLandSaleDates: string[];
};

const BOEIntelStateContext = React.createContext<BOEIntelType>({
  isDataInitialized: false,
  possibleLandSaleDates: [],
});

/*
 *@ deprecated will be replacing with UI storage
 */
export const BOEIntelStateProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [possibleLandSaleDates, setPossibleLandSaleDates] = React.useState<
    string[]
  >([]);
  const { companies } = useCompaniesStorage();
  const { isFetching: isFetchingWorkspaceItems } = useWorkspaceStorage();

  React.useEffect(() => {
    apiCompanyInfoProvider
      .getLandSaleOfferDates()
      .then((possibleOfferDates) => {
        setPossibleLandSaleDates(possibleOfferDates);
      });
  }, []);

  const { isFetching: isFetchingReports } = useIntelReportsStorage();

  const isDataInitializing =
    isEmpty(companies) || isFetchingWorkspaceItems || isFetchingReports;

  return (
    <BOEIntelStateContext.Provider
      value={{
        isDataInitialized: !isDataInitializing,
        possibleLandSaleDates,
      }}
    >
      {children}
    </BOEIntelStateContext.Provider>
  );
};

export const useBOEIntel = () => {
  return React.useContext(BOEIntelStateContext);
};
